module.exports = __webpack_public_path__ + "img/ctrl-p-stub-mid-+.2a192415.svg";